import React, { useEffect, useState  } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import GuessPassword from '../../components/GuessPassword';

function Module18() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    setCanContinue(true);
  };


  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

// Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-18" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-login">
                        <div id="box-wrapper-login-header"><h1>MEGA ENCRYPTION TECHNOLOGIES</h1></div>
                        <div id="box-wrapper-login-body"> 
                            <GuessPassword
                                hashedAnswer="db62c92fa9c6f06636ec0eecfd27f93ef7fc54a4b4aad3826081b41be91bd3f7" // SHA-256 (lowercased)
                                onSuccess={handleSuccess}
                            >
                                <p>Enter the encryption key:</p>
                            </GuessPassword>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module18;
